<script>
// definir un objeto mixin
import { settingsService } from "@/libs/ws/settingsService";
export default {
  data() {
    return {
      valid: false,
      aliasMap: {},
    };
  },
  created: function () {},
  computed: {},
  mounted() {
    this.loadAliasMap();
  },
  methods: {
    loadAliasMap() {
      return settingsService
        .alias_get_map()
        .then((response) => {
          if(response.status) {
            this.aliasMap = response.result;
            this.$forceUpdate();
            console.log("Alias map loaded successfully");
            return true;
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
          return false;
        });
    },
    isAliasEnabled(key){
      if (this.aliasMap && this.aliasMap[key]) {        
        return this.aliasMap[key].enabled;
      }
      return false;
    },
    getAliasControlLabel(key){
      if (this.aliasMap && this.aliasMap[key]) {
        return this.aliasMap[key].control_atribute_label;
      }
      return "";
    },
    getAliasName(key){
      if (this.aliasMap && this.aliasMap[key]) {
        return this.aliasMap[key].name_atribute;
      }
      return "";
    },
    
    addDescriptiveHeadersToArray(headers, keyPrefix, afterKey) {
      // Buscar el índice donde insertar los descriptivos
      const afterIndex = headers.findIndex(header => header.key === afterKey);
      if (afterIndex === -1) return; // Si no encuentra el header de referencia, no hace nada
      
      let insertIndex = afterIndex + 1;
      
      // Agregar descriptivos habilitados dinámicamente
      for (let i = 1; i <= 3; i++) {
        const descriptiveKey = `descriptivo_${i}`;
        if (this.isAliasEnabled(descriptiveKey)) {
          const descriptiveHeader = {
            title: this.getAliasName(descriptiveKey),
            align: "left",
            sortable: true,
            key: `${keyPrefix}.${descriptiveKey}`,
          };
          // Insertar en la posición calculada
          headers.splice(insertIndex, 0, descriptiveHeader);
          insertIndex++; // Incrementar para el siguiente descriptivo
        }
      }
    },

    getMainAttribute(item) {
      const attrs = item;
      
      const attributeOrder = [
        {
          key: 'expiration_date',
          label: 'Vencimiento',
          condition: () => attrs.expiration_date,
          value: () => attrs.expiration_date
        },
        {
          key: 'lote',
          label: 'Lote',
          condition: () => attrs.lote,
          value: () => attrs.lote
        },
        {
          key: 'serie',
          label: 'Serie',
          condition: () => attrs.serie,
          value: () => attrs.serie || "N/A"
        },
        {
          key: 'storage_units_amount',
          label: 'Almacenamiento',
          condition: () => attrs.storage_units_amount,
          value: () => attrs.storage_units_amount 
            ? attrs.storage_units_amount + " " + attrs.product_presentation.product.storage_unit_name
            : "N/A"
        },
        {
          key: 'quality',
          label: 'Calidad',
          condition: () => attrs.quality && attrs.quality.id,
          value: () => attrs.quality.name
        },
        {
          key: 'descriptivo_1',
          label: this.getAliasName("descriptivo_1"),
          condition: () => this.isAliasEnabled('descriptivo_1') && attrs.descriptivo_1,
          value: () => attrs.descriptivo_1
        },
        {
          key: 'descriptivo_2',
          label: this.getAliasName("descriptivo_2"),
          condition: () => this.isAliasEnabled('descriptivo_2') && attrs.descriptivo_2,
          value: () => attrs.descriptivo_2
        },
        {
          key: 'descriptivo_3',
          label: this.getAliasName("descriptivo_3"),
          condition: () => this.isAliasEnabled('descriptivo_3') && attrs.descriptivo_3,
          value: () => attrs.descriptivo_3
        }
      ];

      for (const attr of attributeOrder) {
        if (attr.condition()) {
          return {
            label: attr.label,
            value: attr.value(),
            key: attr.key
          };
        }
      }

      return null;
    },
  },
};
</script>
